import React from 'react';
import UniversalAddItemForm from '../../shared/UniversalAddItemForm';

const AddItemToReceptionForm = ({ refReception, onSuccess }) => {
  return (
    <UniversalAddItemForm
      refField="REF_BR_A"
      refValue={refReception}
      onSuccess={onSuccess}
      priceType="purchase"
      enableBatch={true}
      allowDuplicateArticles={true}
      useArticleList={false}
      extraFields={{ qte_recue: -1, controle: false }}
      submitButtonText="Add all to Reception"
    />
  );
};

export default AddItemToReceptionForm;
